<template>
  <div class="m-anylise">
    <h3>{{ $t("analysis.title") }}</h3>
    <p>
      {{ $t("analysis.tip") }}
    </p>
    <textarea name class="textvalue" v-model="param"></textarea>
    <div
      class="sub-btn flex-center"
      @click="submit"
      :class="{ disabled: isDisabled }"
    >
      {{ $t("analysis.title") }}
    </div>
    <pre class="inputTxt" contenteditable="true" v-if="result"> 
      <code>{{result}}</code>
    </pre>
  </div>
</template>

<script>
import AnyliseBase from "@/mixins/Tool/AlyOrSendTx.js";
export default {
  mixins: [AnyliseBase],
};
</script>

<style lang="scss" scoped>
.m-anylise {
  padding: 11px 20px 17px;
  h3 {
    font-size: 14px;
    font-family: PingFangSC-Semibold;
    color: #53657a;
  }
  p {
    margin: 12px 0 20px;
    color: $font_grey;
    line-height: 20px;
  }
  .sub-btn {
    width: 160px;
    height: 40px;
    margin: 20px auto;
    background: $blue;
    border-radius: 25px;
    color: $white;
    font-size: 14px;
    cursor: pointer;
    transition: 0.3s;
  }
  .sub-btn:hover {
    opacity: 0.8;
  }
  .sub-btn:active {
    opacity: 1;
  }
  .disabled {
    background: $grey_deep;
    cursor: not-allowed;
  }
  .textvalue {
    width: 100%;
    height: 200px;
    padding: 10px;
    background: rgba(255, 255, 255, 1);
    border-radius: 2px;
    border: 2px solid rgba(235, 239, 241, 1);
    resize: none;
    font-size: 14px;
  }
  .inputTxt {
    height: 200px;
    vertical-align: middle;
    overflow-y: auto;
    width: 100%;
    line-height: 14px;
    word-break: break-all;
    padding: 0px 11px;
    background: $white;
    border-radius: 2px;
    border: 2px solid rgba(235, 239, 241, 1);
    font-size: 14px;
  }
  .inputTxt::-webkit-scrollbar,
  .textvalue::-webkit-scrollbar {
    width: 1px;
    height: 1px;
    cursor: pointer;
  }
}
</style>